import _objectSpread from "/var/jenkins_home/workspace/mka-pc_prod/node_modules/@babel/runtime/helpers/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import debounce from 'quasar/src/utils/debounce.js';;
export default {
  props: {
    dictCode: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    'value-key': {
      type: String,
      default: 'itemCode'
    },
    'value-label': {
      type: String,
      default: 'itemName'
    },
    url: {
      type: String,
      default: ''
    },
    json: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: Boolean,
      default: false
    },
    defOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: [String, Number, Object],
      default: ''
    },
    excluded: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    included: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      data: '',
      options: []
    };
  },
  watch: {
    value: {
      handler: function handler(val) {
        if (val) {
          this.data = val;
        }
      },
      immediate: true
    },
    defOptions: {
      handler: function handler(val) {
        var _this = this;
        if (val) {
          this.options = Object.freeze(val);
          var data = this.valueKey && this.json ? this.value[this.valueKey] : this.value;
          var flag = this.options.find(function (item) {
            return item[_this.valueKey] == data;
          });
          if (!flag) {
            if (this.defaultValue) {
              this.data = this.options[0][this.valueKey];
              if (this.data !== null) {
                this.$emit('change', this.options[0]);
              }
            }
          }
        }
      },
      immediate: true
    },
    data: function data(val) {
      this.$emit('input', val);
    },
    dictCode: {
      handler: function handler(val) {
        this.init();
        if (val) {
          this.data = '';
        }
      },
      immediate: true
    }
  },
  computed: {},
  created: function created() {
    var _this2 = this;
    if (this.url) {
      this.apiGet(this.url, {
        pageSize: 10000
      }).then(function (res) {
        var _res$data;
        _this2.options = Object.freeze(((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.content) || res.data);
      });
      return;
    }
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this3 = this;
      var dictCode = this.dictCode;
      if (dictCode) {
        this.apiGet('sysDict', {
          dictCode: this.dictCode,
          pageSize: 10000
        }).then(function (res) {
          var _this3$included, _this3$excluded;
          _this3.options = Object.freeze(res.data);
          if ((_this3$included = _this3.included) !== null && _this3$included !== void 0 && _this3$included.length) {
            _this3.options = _this3.options.filter(function (item) {
              return _this3.included.includes(item.itemCode);
            });
          } else if ((_this3$excluded = _this3.excluded) !== null && _this3$excluded !== void 0 && _this3$excluded.length) {
            _this3.options = _this3.options.filter(function (item) {
              return !_this3.excluded.includes(item.itemCode);
            });
          }
          var data = _this3.valueKey && _this3.json ? _this3.value[_this3.valueKey] : _this3.value;
          var flag = _this3.options.find(function (item) {
            return item[_this3.valueKey] == data;
          });
          if (!flag) {
            if (_this3.defaultValue) {
              _this3.data = _this3.options[0][_this3.valueKey];
              _this3.$emit('change', _this3.options[0]);
            }
          }
          _this3.$emit('ready', _this3.options.length ? _this3.options : [{}]);
        });
      }
    },
    onChange: function onChange(e) {
      var _this4 = this;
      if (!this.json) {
        var option = {};
        this.options.forEach(function (item) {
          if (e == item[_this4.valueKey]) {
            option = _objectSpread({}, item);
          }
        });
        this.$emit('change', option);
      } else {
        this.$emit('change', e);
      }
    }
  }
};